// put this above your Modal code (same file) or in its own file
import React, { useMemo, useState } from "react"
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from "reactstrap"

const BLUE = "#2990DF"

function TemplatePicker({ templates = [], mode, onSelect }) {
  const [page, setPage] = useState(1)
  const pageSize = 5

  const { current, totalPages } = useMemo(() => {
    const safe = Array.isArray(templates) ? templates : []
    const totalPages = Math.max(1, Math.ceil(safe.length / pageSize))
    const start = (page - 1) * pageSize
    const end = start + pageSize
    return { current: safe.slice(start, end), totalPages }
  }, [templates, page])

  const paginate = p => p >= 1 && p <= totalPages && setPage(p)

  return (
    <>
      {/* Active page color override */}
      <style>{`
        .pagination .page-item.active .page-link {
          background-color: ${BLUE};
          border-color: ${BLUE};
          color: #fff;
        }
        .pagination .page-link:focus {
          box-shadow: 0 0 0 0.25rem rgba(41,144,223,0.25);
        }
      `}</style>

      <div
        className="template-list"
        style={{
          maxHeight: 320, // keep modal body tidy
          overflowY: "auto",
          paddingRight: 6,
        }}
      >
        {current.length > 0 ? (
          current.map(t => (
            <div
              key={t.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 6px",
                borderBottom:
                  mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontWeight: 600,
                    color: mode === "dark" ? "#fff" : "#111827",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={t.title}
                >
                  {t.title}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: mode === "dark" ? "#d1d5db" : "#4b5563",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={t.description}
                >
                  {t.description}
                </div>
              </div>

              <button
                onClick={() => onSelect(t)}
                style={{
                  border: `1px solid ${BLUE}`,
                  color: BLUE,
                  backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
                  padding: "6px 10px",
                  borderRadius: 6,
                  outline: "none",
                  cursor: "pointer",
                }}
              >
                Select
              </button>
            </div>
          ))
        ) : (
          <p style={{ margin: 0 }}>No templates available.</p>
        )}
      </div>

      {/* Pagination */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center">
          <Pagination className="mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink previous onClick={() => paginate(page - 1)} />
            </PaginationItem>

            {Array.from({ length: totalPages }).map((_, i) => (
              <PaginationItem active={i + 1 === page} key={i}>
                <PaginationLink onClick={() => paginate(i + 1)}>
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={page === totalPages}>
              <PaginationLink next onClick={() => paginate(page + 1)} />
            </PaginationItem>
          </Pagination>
        </Col>
      </Row>
    </>
  )
}

export default TemplatePicker
